module.exports = __webpack_public_path__ + "img/credit_card_24dp.daa2352c.svg";